<template>
  <section v-loading="loading" id="view-test-information" class="default-modal">
    <div class="case-creation__card">
      <div class="test-tabs reportsTableWidth" id="vue-tabs">
        <div class="test-panel">
          <div class="primary-content-view-new" v-loading="loading">
            <div v-if="getCaseInformation?.test_reports?.length" class="listings listings__table listings__all-cases" id="all-cases-listings">
              <el-table :data="getCaseInformation?.test_reports" style="width: 100%">
                <el-table-column prop="action" label="REPORTS" width="350">
                  <template #default="scope">
                    <ul class="action-test-icons view-test">
                      <li style="margin-right: 10px" >
                        <div class="column-status" v-if="scope.row.result_status">
                          <span class="el-dropdown-link">
                            <el-tag :type="getCovidStatusType(scope.row.result_status)
                              ">{{ scope.row.result_status }}</el-tag>
                          </span>
                        </div>
                      </li>
                      <li>
                        <el-button class="action-download"
                          @click="onDownloadReport(scope.row)" title="Download">
                          <span>
                            <img class="testreports-active" src="@/assets/images/icons/Download_1.svg"
                              alt="icon" style="width: 22px" />
                          </span>
                        </el-button>
                      </li>
                      <li>
                        <el-button class="action-view" @click="viewReport(scope.row)" title="View">
                          <img class="testreports-active" src="@/assets/images/icons/view_1.svg" alt="icon"
                            style="width: 22px" />
                        </el-button>
                      </li>
                    </ul>
                  </template>
                </el-table-column>
                <el-table-column prop="time" label="DATE & TIME" width="300">
                  <template #default="scope">
                    <span>
                      {{
                        momentWithTimezone(
                          scope.row.time,
                          "MM-DD-YYYY hh:mm A"
                        )
                      }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column prop="mark" label="MARK FOR PHYSICIAN" width="300">
                  <template #default="scope">
                    <div class="physician-btn">
                      <el-switch @change="
                        (value) =>
                        updateReportPhysicianStatus(value, scope.row)" 
                        :model-value="scope.row.mark_for_physician">
                      </el-switch>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="type" label="TYPE" width="270">
                  <template #default="scope" >
                    <span v-if="scope.row.is_amendement"
                          >Amendement Report</span
                    >
                    <span v-else>{{ scope.row.type  ? scope.row.type : 'Regular Report' }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div v-else style="text-align: center; color: red; font-weight: 600; padding: 20px 0;">
              <span>No test reports found</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from "vuex";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import AppHelper from "@/mixins/AppHelper";
import caseDataHelper from "@/mixins/caseDataHelper";
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
export default {
  props: ["caseIdProp", "openPopup", "displayUploading"],
  data() {
    return {
      additionalReportsPopup: false,
      files: [],
      caseId: "",
      loading: false,
      testReports: [],
      selectedReportForEditTitle: {},
      loadingText: "Fetching Reports...",
    };
  },
  async mounted() {
    this.caseId = this.$route.params.case_id;
    await this.$store.commit("errors/clear", null, { root: true });
    await this.checkCaseInformation();
  },
  mixins: [UserPermissionsHelper, AppHelper, caseDataHelper],
  computed: {
    ...mapGetters("resultFiles", [
      "getDiscreteResultsDetails",
      "getRemoveDiscreteResultsStatus",
      "getDiscreteResultsMismatchedTests"
    ]),
    getCovidStatusType() {
      return (statusVal) => {
        const status = statusVal;
        if (status == "POSITIVE") {
          return "danger";
        } else if (status == "NEGATIVE") {
          return "success";
        } else if (status == "INCONCLUSIVE") {
          return "info";
        } else if (status == "INCONSISTENT") {
          return "warning";
        } else if (status == "CONSISTENT") {
          return "success";
        } else {
          return "";
        }
      };
    },
    ...mapGetters("cases", [
      "getCaseInformation",
      "getReportPreview",
      "getReportPhysicianStatusUpdated"
    ]),
    ...mapGetters("errors", ["getError", "getErrors"]),
  },
  methods: {
    async updateReportPhysicianStatus(status, report){
      try {
        this.loading = true
        let params = {
          case_id : this.caseId || this.getCaseInformation._id,
          report_id:report._id,
          status:status
        }
        await this.$store.dispatch("cases/updateTestReportPhysicianStatus",params)
        if(this.getReportPhysicianStatusUpdated){
          successNotification("Report finalized successfully!")
          await this.checkCaseInformation();
        }
        else {
          errorNotification(this.getError || ("Error while finalizing the report"))
        }
        this.loading = false
      } catch(err){
        console.log(err)
      } finally{
        this.loading = false
      }
    },
    async onDownloadReport(report) {
      try {
        this.loading = true;
        this.$store.commit("errors/clear", null, { root: true });
        await this.$store.dispatch("cases/fetchReportPreview", {
          id: report._id,
          caseId: this.caseId
        });
        let url = this.getReportPreview?.download_url;
        if (url) {
          window.open(url, "_blank");
          successNotification("Report opened successfully");
        } else {
          errorNotification("Error while opening report");
        }
      } catch (err) {
        errorNotification("Error while downloading report");
      } finally {
        this.loading = false;
      }
    },
    async checkCaseInformation() {
      this.loading = true;
      await this.$store.dispatch("cases/fetchCaseInformation", this.caseId);
      this.loading = false;
    },
    async viewReport(report) {
      let routerData = this.$router.resolve({
        name: "supplementaryReportView",
        params: {
          report_id: report._id,
          case_id: this.getCaseInformation._id,
        },
      });
      await this.checkCaseInformation();
      window.open(routerData.href, "_blank");
    },
  },
};
</script>
<style lang="scss">
.case-creation__heading {
  overflow: hidden;
}
#view-test-information {
  .test-reports {
    display: grid;
    grid-template-columns: 200px auto;
    column-gap: 15px;

    // height: 25px;
    .el-switch .el-switch__core {
      width: 34px !important;
      height: 14.5px;
      border: none;
      background-color: #0a5da6;

      .el-switch__action {
        height: 10px;
        width: 10px;
        top: 2px;
        left: 2.1px;
      }
    }

    .el-switch__label.is-active {
      color: #0a5da6;
    }

    .el-switch.is-checked {
      .el-switch__core {
        background-color: #4bb543 !important;
      }

      .el-switch__action {
        height: 10px;
        width: 10px;
        top: 2px;
        left: 38px;
      }
    }

    .single-reports {
      margin-left: 20px;
    }
  }

  .el-table::before {
    left: 0;
    bottom: 0;
    width: 100%;
    height: 0px;
  }

  .test-tabs {
    // padding: 0 10px;

    .el-tabs__nav-scroll {
      padding: 0 15px;
    }

    .el-tabs__nav-wrap::after {
      height: 1px;
    }

    .test-panel {
      padding: 10px;

      .title-icon {
        padding: 0 6px;
        min-height: 20px;
        border: none;
        background: none;

        img {
          vertical-align: text-top;
        }
      }

      .icons {
        display: flex;
        justify-content: flex-end;
        padding: 2px 7px 12px 7px;

        .el-button {
          padding: 0;
          min-height: 21px;
          border: none;
          background: none;
        }

        .el-icon {
          .icon {
            width: 18px;
            height: 18px;
            color: #2979ff;
            padding-top: 3px;
          }

          &.cancel {
            margin-left: 8px;
          }
        }
      }
    }

    .el-tabs__active-bar {
      background-color: #0a5da6;
      border-radius: 25px;

      height: 2px;
    }

    .el-tabs__item.is-active {
      color: #0a5da6;
      font-weight: 500;
    }

    .el-tabs__item:hover {
      color: #828282;
    }

    .el-tabs__item {
      color: #828282;
    }

    .el-table {
      .el-table__cell {
        .cell {
          font-weight: 500 !important;
        }
      }
    }

    .types {
      padding-top: 1rem;

      .el-form-item {
        display: block !important;
        margin: 0;
      }

      .case-type {
        &.view-reports-dialog {
          .el-button {
            border: 1px dashed #bababc;
            min-height: 30px;
            padding: 0 34px;
            background-color: #f2f6f9;
            width: 100%;
            font-size: 11px;

            span {
              display: flex;
              align-items: center;
              justify-content: center;
              color: #333333;

              p {
                color: #333333;
                font-weight: 400;
              }

              img {
                margin-right: 6px;
              }
            }
          }
        }

        .el-input__inner {
          border: 1px solid #56ccf2cc;
          height: 30px;
        }
      }

      .btn {
        margin-top: 22px;

        .el-button {
          color: #fff;
          padding: 8px 24px;
          min-height: 30px;
          border-radius: 7px;
          background: linear-gradient(79.26deg,
              #f24a55 -13.43%,
              #0a5da6 137.71%);
          border: none;
        }

        .submit-report {
          color: #fff;
          padding: 8px 24px;
          min-height: 30px;
          border-radius: 7px;
          background: linear-gradient(79.26deg,
              #f24a55 -13.43%,
              #0a5da6 137.71%);
          border: none;
        }
      }
    }

    .view-test {
      display: flex;
      font: icon;
      align-items: center;

      .el-button {
        padding: 0;
        margin-right: 10px;
        min-height: 20px;
        border: none;
        background: none;
      }

      .resend-notify-button {
        color: #10182f;
        margin-right: 7px;
        padding: 4px 0;
        border-radius: 5px;

        &:hover {
          color: #0a5da6;
        }

        &.replace {
          padding: 4px 8px;
          border: 1px solid #273480;

          &:hover {
            color: #273480;
            padding: 4px 8px;
            border: 1px solid #273480;
          }
        }
      }

      .discrete-results-btn {
        color: #737373;
        padding: 0;
        font-weight: 600;
        border-radius: 5px;

        &:hover,
        &:focus,
        &:active {
          color: #c5314c;
          padding: 0;
          font-weight: 600;
          border-radius: 5px;
          transform: scale(1.1);
        }
      }
    }

    .test-panel {
      padding: 10px;

      .el-table {
        background: #eef2f5;

        // padding: 0 10px;
        .el-table__cell {
          padding: 5px 0;
        }
      }

      .el-table__header {
        border-spacing: 0 2.5px;
        color: rgba(0, 0, 0, 0.8);
      }

      .el-table__body {
        border-spacing: 0 2.5px;
      }

      .el-table__body-wrapper {
        overflow: initial !important;
      }

      .el-table__header-wrapper {
        overflow: initial !important;
      }

      .el-table thead {
        color: rgba(0, 0, 0, 0.8);
        font-weight: 500;
      }

      .hours {
        margin-left: 10px;
      }

      .el-icon-edit {
        min-height: 25px;
        padding: 0 5px;
        background-color: #f24a55;
        color: #ffff;
        border: none;
      }

      .edit-icon {
        cursor: pointer;
        position: relative;

        top: 3px;
      }
    }
  }

  .fax-resend-popup {
    .el-form-item {
      display: grid;
      grid-template-columns: 45% 55%;
      margin-bottom: 5px;
    }

    .el-form-item__label {
      text-align: start;
      padding: 0 20px;
      width: 250px !important;
    }

    .el-tag {
      margin-right: 7px;
    }

    .additionalFaxSelect {
      .el-select .el-select__tags>span {
        display: block !important;
      }

      .el-select {
        width: 92% !important;
      }

      .el-select__tags {
        flex-wrap: wrap !important;
      }
    }
  }

  .notes-btn {
    margin-top: 5px;
    text-align: center;

    .btn {
      padding: 5px 7px;
      height: 22px;
      font-size: 12px;
      min-height: 22px;
      background-color: #273480;
      border: none;
      color: white;

      &.cancel {
        background-color: transparent;
        color: #f24a55;
        border: 0.719521px solid #dedbdb;
      }
    }
  }

  .physician-btn {
    .el-switch .el-switch__core {
      width: 34px !important;
      height: 15px;
      border: none;
      background-color: #0a5da6;

      .el-switch__action {
        height: 9px;
        width: 9px;
        top: 3px;
        left: 2px;
      }
    }

    .el-switch__label.is-active {
      color: #0a5da6;
    }

    .el-switch.is-checked {
      .el-switch__core {
        width: 34px !important;
        height: 15px;
        border: none;
        background-color: #4bb543 !important;
      }

      .el-switch__action {
        height: 10px;
        width: 10px;
        top: 2.2px;
        left: 38.5px;
      }
    }
  }

  .tox-finalize-btn {
    margin-left: 20px;

    .el-button {
      border: 0.6px solid #273480;
      background: #f2f2f2;
      color: #273480;
      min-height: auto;
      padding: 5px 15px;
      text-align: center;
      font-size: 13px;
      letter-spacing: 0;

      &:hover,
      &:focus {
        color: #273480;
        border: 0.6px solid #273480;
        background: #f2f2f2;
      }
    }
  }

  .upload-files-alignment-block {
    .upload-files-alignment {
      width: 100%;
      margin: auto;
      margin-bottom: 10px;
    }
  }

  .default-modal {
    .popup-date {
      .el-upload {
        width: 100%;
      }

      .upload-demo,
      .el-upload-dragger {
        width: 100%;
        margin: auto;
        height: 120px;
        background: #c4c4c41f !important;

        border: 0.6px dashed #c4c4c41f;
        border-radius: 6px;
      }

      .el-upload-text-align {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        padding-top: 30px;

        .el-upload__text-img {
          display: flex;
          align-items: center;

          img {
            width: 40px;
            height: 40px;
            padding: 0 10px;
          }
        }

        .el-upload-text {
          line-height: 14px;

          h3 {
            color: #333333;
            font-size: 18px;
          }

          p {
            color: #828282;
            font-size: 18px;
          }
        }
      }
    }
  }

  .active-report-new {
    .el-table tr {
      background-color: red !important;
    }
  }
}
.reportsTableWidth {
  .el-table {
    table {
      width: 100% !important;
    }
  }

  .el-table__body-wrapper {
    width: 100% !important;
  }
}
</style>